export const successMessageMapping: any = {
  grammar: 'Grammar fixed by Convrt AI. Your message is now polished!',
  shorten: 'Message shortened by Convrt AI. Review your concise text!',
  casual: 'Message transformed to a casual tone by Convrt AI. Check out the friendly vibe!',
  formal: 'Message elevated to formal elegance by Convrt AI. Examine the professional tone!',
}
